import { Bell, BellRing, LoaderCircle } from 'lucide-react';
import { useAuth } from '../lib/auth';
import { useTraders } from '../lib/trader-context';

export function FollowTraderButton({ owner }: { owner: string }) {
  const auth = useAuth(), traders = useTraders();
  const following = Boolean(auth.owner && traders.following.has(owner));
  const pending = traders.pending.has(owner);
  return <button
    className={`follow-trader-button${following ? ' following' : ''}`}
    type="button"
    aria-pressed={following}
    aria-label={following ? 'Unfollow trader' : auth.owner ? 'Follow trader for buy and sell notifications' : 'Sign in to follow trader'}
    disabled={pending || auth.busy || !auth.ready || (Boolean(auth.owner) && traders.loading)}
    title={following ? 'Buy and sell notifications are on. Click to unfollow.' : 'Get a notification when this trader buys or sells.'}
    onClick={() => void traders.toggleFollow(owner)}
  >{pending ? <LoaderCircle size={13} className="spin" /> : following ? <BellRing size={13} /> : <Bell size={13} />}{pending ? 'Saving…' : following ? 'Following' : 'Follow'}</button>;
}
